import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import { AlertAction, AlertMutation, AlertState } from "../types";

const updateAlert = (
  context: ActionContext<AlertState, RootState>,
  alertInfo: AlertState
): void => {
  context.commit(AlertMutation.SetShow, alertInfo.show);
  if (alertInfo.message)
    context.commit(AlertMutation.SetMessage, alertInfo.message);
  if (alertInfo.alertType)
    context.commit(AlertMutation.SetAlertType, alertInfo.alertType);
};

export const actions: ActionTree<AlertState, RootState> &
  Record<AlertAction, Action<AlertState, RootState>> = {
  [AlertAction.UpdateAlert]: updateAlert
};
